// extracted by mini-css-extract-plugin
module.exports = {"not-found":"not-found--3apaA","not-found__button":"not-found__button--OHduo"};